import Constants from 'config/Constants';
import { useContext, useEffect, useState } from 'react';
import { AddBlockModal } from 'pages/documents_v2/views/edit_area/modals/AddBlockModal';
import { useGetDocument } from 'pages/documents_v2/hooks/useGetDocument';
import getTemplateParameters from 'components/SettingsSidebar/views/TemplateConstants';
import { NumberParam, useQueryParam } from 'use-query-params';
import { EditAreaContext } from 'pages/documents_v2/views/edit_area/context/EditAreaContext';

export function AddBlock({ area }) {
    const document = useGetDocument();
    const { addBlock } = useContext(EditAreaContext);
    const [insertBlockIndex, setInsertBlockIndex] = useQueryParam('ibi', NumberParam);
    const [showAddBlockModal, setShowAddBlockModal] = useState(false);
    const [defaultBlockType, setDefaultBlockType] = useState(Constants.blockTypes.text);

    useEffect(() => {
        if (insertBlockIndex >= 0 && !showAddBlockModal) {
            setShowAddBlockModal(true);
        }
    }, [insertBlockIndex, showAddBlockModal]);

    useEffect(() => {
        if (document.modelId) {
            setDefaultBlockType('template_block');
        }
    }, [document]);

    return (
        <AddBlockModal
            show={showAddBlockModal}
            defaultBlockType={defaultBlockType}
            hide={() => {
                setInsertBlockIndex(undefined);
                setShowAddBlockModal(false);
            }}
            onSubmit={onSubmit}
            area={area}
            insertBlockIndex={insertBlockIndex}
            canEditVariants={
                document.type === Constants.documentType.default ||
                document.type === Constants.documentType.terms_conditions
            }
        />
    );

    function onSubmit(values) {
        let properties = {};

        if (values.blockType === Constants.blockTypes.table) {
            properties.templateId = values.templateId;
        }

        const templateParameters = getTemplateParameters(values.blockType);
        const justTheParameters = Object.assign({}, ...Object.values(templateParameters));

        properties = { ...properties, templateParameters: justTheParameters };

        addBlock(values.blockType, values.variants, properties, undefined, insertBlockIndex);

        // Close modal
        setInsertBlockIndex(undefined);
        setShowAddBlockModal(false);
    }
}
